import styled /*, { keyframes }*/ from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  // background: black;
  background-image: url("/play-cash-codebreakers/assets/images/paper_texture.png");
  background-repeat: repeat;
`;

export { Wrapper };
